<template>
  <a-modal
    :title="modalTitle"
    :visible="visible"
    @ok="handleOk"
    @cancel="handleCancel"
    :confirmLoading="loading"
    width="800px"
  >
    <a-form-model
      ref="form"
      :model="formData"
      :rules="rules"
      :label-col="{ span: 6 }"
      :wrapper-col="{ span: 18 }"
    >
      <!-- 账户类型选择 -->
      <a-form-model-item label="账户类型" prop="accountType">
        <a-radio-group v-model="formData.accountType" @change="onAccountTypeChange">
          <a-radio :value="2">USDT(TRC20)</a-radio>
          <a-radio :value="1">银行账户</a-radio>
        </a-radio-group>
      </a-form-model-item>

      <!-- 银行账户字段 -->
      <template v-if="formData.accountType === 1">
        <a-form-model-item label="账户别名" prop="accountName">
          <a-input v-model="formData.accountName" placeholder="请输入账户别名" />
        </a-form-model-item>
        <a-form-model-item label="IFSC Code" prop="ifscCode">
          <a-input
            v-model="formData.ifscCode"
            placeholder="请输入4位银行代码(如:HDFC)或11位完整IFSC代码"
            @blur="onIfscCodeBlur"
            @input="onIfscCodeInput"
          />
          <div v-if="ifscQueryStatus === 'success'" class="ifsc-bank-info success">
            <a-icon type="check-circle" /> 识别银行: {{ bankNameFromIFSC }}
          </div>
          <div v-else-if="ifscQueryStatus === 'failed'" class="ifsc-bank-info error">
            <a-icon type="exclamation-circle" /> 银行代码无效，请手动输入银行名称
          </div>
          <div v-else-if="ifscQueryStatus === 'loading'" class="ifsc-bank-info loading">
            <a-icon type="loading" /> 正在查询银行信息...
          </div>
        </a-form-model-item>

        <a-form-model-item label="银行名称" prop="bankName">
          <a-input
            v-model="formData.bankName"
            placeholder="请输入银行名称"
            :disabled="ifscQueryStatus === 'success'"
          />
          <div v-if="ifscQueryStatus === 'success'" class="bank-name-tip">
            银行名称已根据IFSC代码自动填充
          </div>
        </a-form-model-item>

        <a-form-model-item label="收款人姓名" prop="payeeName">
          <a-input v-model="formData.payeeName" placeholder="请输入收款人姓名" />
        </a-form-model-item>
        <a-form-model-item label="账户号码" prop="accountNo">
          <a-input v-model="formData.accountNo" placeholder="请输入账户号码" />
        </a-form-model-item>
      </template>

      <!-- USDT账户字段 -->
      <template v-if="formData.accountType === 2">
        <!-- 账户名称 -->
        <a-form-model-item label="账户别名" prop="accountName">
          <a-input v-model="formData.accountName" placeholder="请输入账户别名" />
        </a-form-model-item>
        <a-form-model-item label="USDT地址" prop="accountNo">
          <a-input v-model="formData.accountNo" placeholder="请输入USDT地址" />
        </a-form-model-item>

        <a-form-model-item label="银行名称" prop="bankName">
          <!-- 选择usdt 默认 银行名称：USDT(TRC20)  -->
          <a-input v-model="formData.bankName" placeholder="请输入银行名称" :disabled="formData.accountType === 2" />
        </a-form-model-item>

      </template>

      <!-- 通用字段 -->
      <a-form-model-item label="是否默认" prop="isDefault">
        <a-switch
          :checked="formData.isDefault === 1"
          @change="(checked) => formData.isDefault = checked ? 1 : 0"
        >
          <span slot="checkedChildren">是</span>
          <span slot="unCheckedChildren">否</span>
        </a-switch>
      </a-form-model-item>

      <!-- <a-form-model-item label="状态" prop="status">
        <a-switch
          :checked="formData.status === 1"
          @change="(checked) => formData.status = checked ? 1 : 0"
        >
          <span slot="checkedChildren">启用</span>
          <span slot="unCheckedChildren">禁用</span>
        </a-switch>
      </a-form-model-item> -->
    </a-form-model>
  </a-modal>
</template>

<script>
import { getBankNameByIFSC, validateIFSCFormat, formatIFSCCode } from '@/utils/ifscUtil'

export default {
  name: 'AccountFormModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    initialData: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      bankNameFromIFSC: '',
      ifscQueryStatus: '', // 'loading', 'success', 'failed', ''
      formData: {
        id: null,
        accountType: 2, // 默认选择USDT
        ifscCode: '',
        bankName: '',
        payeeName: '',
        accountName: '',
        accountNo: '',
        isDefault: 0,
        status: 1
      },
      rules: {
        accountType: [
          { required: true, message: '请选择账户类型', trigger: 'change' }
        ],
        ifscCode: [
          { required: true, message: '请输入IFSC Code', trigger: 'blur' },
          { validator: this.validateIFSC, trigger: 'blur' }
        ],
        bankName: [
          { required: true, message: '请输入银行名称', trigger: 'blur' }
        ],
        payeeName: [
          { required: true, message: '请输入收款人姓名', trigger: 'blur' }
        ],
        accountName: [
          { required: true, message: '请输入账户名称', trigger: 'blur' }
        ],
        accountNo: [
          { required: true, message: '请输入账户号码', trigger: 'blur' }
        ],
        usdtAddress: [
          { required: true, message: '请输入USDT地址', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    modalTitle () {
      return this.isEdit ? '修改银行账户' : '新建银行账户'
    }
  },
  watch: {
    visible (val) {
      if (val) {
        this.initFormData()
      }
    },
    initialData: {
      handler (val) {
        if (val && Object.keys(val).length > 0) {
          this.formData = { ...this.getDefaultFormData(), ...val }
          // 如果是USDT账户类型，确保银行名称正确
          if (this.formData.accountType === 2) {
            this.formData.bankName = 'USDT(TRC20)'
          }
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    // 获取默认表单数据
    getDefaultFormData () {
      return {
        id: null,
        accountType: 2, // 默认选择银行账户
        ifscCode: '',
        bankName: 'USDT(TRC20)',
        payeeName: '',
        accountName: '',
        accountNo: '',
        usdtAddress: '',
        isDefault: 0,
        status: 1
      }
    },

    // 初始化表单数据
    initFormData () {
      if (this.isEdit && this.initialData && Object.keys(this.initialData).length > 0) {
        this.formData = { ...this.initialData }
        // 如果是USDT账户类型，确保银行名称正确
        if (this.formData.accountType === 2) {
          this.formData.bankName = 'USDT(TRC20)'
        }
        // 如果是编辑模式且有IFSC代码，查询银行信息
        if (this.formData.ifscCode) {
          this.queryBankNameByIFSC(this.formData.ifscCode)
        }
      } else {
        this.formData = this.getDefaultFormData()
        this.resetIfscStatus()
      }
      // 清除表单验证状态
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.clearValidate()
        }
      })
    },

    // 重置IFSC状态
    resetIfscStatus () {
      this.bankNameFromIFSC = ''
      this.ifscQueryStatus = ''
    },

    // 账户类型变化
    onAccountTypeChange () {
      // 清空相关字段
      this.formData.ifscCode = ''
      this.formData.bankName = ''
      this.formData.payeeName = ''
      this.formData.accountNo = ''
      this.formData.usdtAddress = ''
      this.resetIfscStatus()
      // 如果选择usdt 默认 银行名称：USDT(TRC20)
      if (this.formData.accountType === 2) {
        this.formData.bankName = 'USDT(TRC20)'
      }
    },

    // IFSC代码输入事件
    onIfscCodeInput () {
      // 输入时重置状态，避免显示过期的查询结果
      if (this.ifscQueryStatus !== '') {
        this.resetIfscStatus()
        // 如果银行名称是自动填充的，清空它
        if (this.ifscQueryStatus === 'success') {
          this.formData.bankName = ''
        }
      }
    },

    // IFSC代码失焦事件
    onIfscCodeBlur () {
      if (this.formData.ifscCode && this.formData.ifscCode.trim()) {
        const formattedCode = formatIFSCCode(this.formData.ifscCode.trim())
        this.formData.ifscCode = formattedCode
        this.queryBankNameByIFSC(formattedCode)
      } else {
        this.resetIfscStatus()
      }
    },

    // 根据IFSC代码查询银行名称
    queryBankNameByIFSC (ifscCode) {
      // 首先验证格式（支持4位或11位）
      if (!validateIFSCFormat(ifscCode)) {
        this.ifscQueryStatus = 'failed'
        this.bankNameFromIFSC = ''
        return
      }

      // 设置加载状态
      this.ifscQueryStatus = 'loading'

      // 模拟异步查询（实际项目中可能需要调用API）
      setTimeout(() => {
        const bankName = getBankNameByIFSC(ifscCode)

        if (bankName && bankName !== 'Unknown Bank') {
          // 查询成功
          this.ifscQueryStatus = 'success'
          this.bankNameFromIFSC = bankName
          this.formData.bankName = bankName
        } else {
          // 查询失败 - 格式正确但找不到银行
          this.ifscQueryStatus = 'failed'
          this.bankNameFromIFSC = ''
          // 不清空用户可能已经输入的银行名称
        }
      }, 300) // 减少延迟时间
    },

    // 验证IFSC代码
    validateIFSC (rule, value, callback) {
      if (!value) {
        callback()
        return
      }

      // 验证格式（支持4位前缀或11位完整代码）
      if (!validateIFSCFormat(value)) {
        if (value.length === 4) {
          callback(new Error('请输入正确的4位银行代码'))
        } else if (value.length === 11) {
          callback(new Error('请输入正确的11位IFSC代码格式'))
        } else {
          callback(new Error('请输入4位银行代码或11位完整IFSC代码'))
        }
      } else {
        // 格式正确，检查是否存在于银行映射表中
        const bankName = getBankNameByIFSC(value)
        if (bankName === 'Unknown Bank') {
          callback(new Error('银行代码不存在，请检查输入'))
        } else {
          callback()
        }
      }
    },

    // 弹窗确认
    handleOk () {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return
        }

        // 处理提交数据
        const submitData = { ...this.formData }

        // 如果是银行账户且IFSC查询成功，确保银行名称正确
        if (submitData.accountType === 1 && this.ifscQueryStatus === 'success') {
          submitData.bankName = this.bankNameFromIFSC
        }

        // 如果是USDT账户，设置相应字段
        if (submitData.accountType === 2) {
          submitData.ifscCode = ''
          submitData.payeeName = ''
          submitData.bankName = 'USDT(TRC20)'
        }

        this.$emit('submit', submitData)
      })
    },

    // 弹窗取消
    handleCancel () {
      this.$emit('cancel')
    },

    // 重置表单
    resetForm () {
      this.formData = this.getDefaultFormData()
      this.resetIfscStatus()
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.clearValidate()
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.ant-form-model-item {
  margin-bottom: 24px;
}

.ant-radio-group {
  .ant-radio-wrapper {
    margin-right: 16px;
  }
}

.ifsc-bank-info {
  margin-top: 4px;
  color: #52c41a;
  font-size: 12px;
}

.success {
  color: #52c41a;
}

.error {
  color: #f5222d;
}

.loading {
  color: #1890ff;
}

.bank-name-tip {
  margin-top: 4px;
  color: #909399;
  font-size: 12px;
}
</style>
